import React from "react";
import { Grid } from "@material-ui/core";
import './cardStyle.css'

const FeatureCard = (props) => {
  return (
        <Grid
            xs={12}
            sm={6}
            md={4}
            className="px-sm-3 mt-5"
        >
            <div className="QMF---FeatureCards px-4 py-5 mx-auto" style={{
                  boxShadow: 'rgb(255 166 63) 0px 4px 30px'}}>
                <img src={props.img} className="img-fluid" alt="Card Icon Missing" />
                <h2 className=" text-uppercase mt-3">{props.title}</h2>
                <p className=" mb-0">{props.details1}</p>
            </div>
        </Grid>
  );
}

export default FeatureCard;
